import shieldIcon from '../../../../images/Icons/shield-icon.svg';
import coinIcon from '../../../../images/Icons/coin-icon.svg';
import ratingsIcon from '../../../../images/Icons/ratings-icon.svg';
import carIcon from '../../../../images/Icons/car-icon.svg';

const cardContentPro = [
  {
    icon: shieldIcon,
    title: 'Safe & secure',
    text:
      'Riders feel safer in Autzu’s premium vehicles, increasing customer satisfaction which means better ratings for you!'
  },
  {
    icon: ratingsIcon,
    title: 'Drive in style',
    text:
      'Provide your riders with top-notch quality and comfort. Happy riders leave higher tips.'
  },
  {
    icon: coinIcon,
    title: 'Higher earnings',
    text:
      'Earn more with UberCOMFORT, UberSELECT, UberX & UberPOOL trips. UberSELECT drivers receive higher earnings and better ratings.'
  },
  {
    icon: carIcon,
    title: 'Premium cars',
    text:
      'Autzu’s PRO fleet features BMW 3 Series, and BMW X1/X2 vehicles.'
  }
];

export default cardContentPro;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/AutzuPro/CardContentPro.js